/*
import TacosContainerPage from './views/TacosContainerPage'
import {ReguserContainerCom} from './containers'
import SVESOrderComPage from './views/SVESOrderComPage'
import SVTPOrderComPage from './views/SVTPOrderComPage'
import StoredcardsWithCustprofilePage from './views/StoredcardsWithCustprofilePage'
*/

//const PROMO_DISABLED = true 
/*sjjan10  enable tjis when we make HB code changes in PY ., AMD already has this */
export const SVR_CDN_ADDRESS =  "https://svsrsoj.b-cdn.net"
export const CDN_PROM_ADDRESS = "https://svsrsoj.b-cdn.net/images/"
export const SVCR_PROMO_RQ = {
    "svfields": [
        "images",
        "sojourn_name",
        "address",
        "code",
        "sojournGeocode",
        "categoryCode",
        "categoryGroupCode",
        "accommodationTypeCode",
        "sojourn_city",
        "countryCode",
        "stateCode",
        "postalCode",
        "countryCode",
        "ranking",
        "web",
        "terminals",
        "destinationCode"
    ],
    "dates": {
        "STARTDATE_ITN_TZAWARE_EST": "2026-04-03",
        "ENDDATE_ITN_TZAWARE_EST": "2026-04-30",
        "DT_FORMAT": "%Y-%m-%d",
        "time_zone": "Asia/Kolkata",
        "OP": "range"
    },
    "facets": {
        "accommodationTypeCode": "H"
    },
    "esqueryChilds": "m1",
    "esqueryInfants": "i0",
    "esqueryAdults": "t1",
    "esquerySpecials": "J",
    "esqueryTripType": "roundtrip",
    "svpageSize": 5,
    "codeKeys": [],
    "esqueryPortcall": "ADL",
    "esqueryShip": "FN",
    "esqueryDur": "D1",
    "org": "LAX",
    "dst": "MIA"
}

export const SVCR_HOME_RQ = {
    "svfields": [
        "images",
        "sojourn_name",
        "address",
        "code",
        "sojournGeocode",
        "categoryCode",
        "categoryGroupCode",
        "accommodationTypeCode",
        "sojourn_city",
        "countryCode",
        "stateCode",
        "postalCode",
        "countryCode",
        "ranking",
        "web",
        "terminals",
        "destinationCode"
    ],
    "dates": {
        "STARTDATE_ITN_TZAWARE_EST": "2026-04-03",
        "ENDDATE_ITN_TZAWARE_EST": "2026-04-30",
        "DT_FORMAT": "%Y-%m-%d",
        "time_zone": "Asia/Kolkata",
        "OP": "range"
    },
    "facets": {
        "accommodationTypeCode": "H"
    },
    "esqueryChilds": "m1",
    "esqueryInfants": "i0",
    "esqueryAdults": "t1",
    "esquerySpecials": "J",
    "esqueryTripType": "roundtrip",
    "svpageSize": 5,
    "codeKeys": [],
    "esqueryPortcall": "ADL",
    "esqueryShip": "FN",
    "esqueryDur": "D1",
    "org": "LAX",
    "dst": "MIA"
}
export const HB_BRAND_FILTER_ENABLED = true
export const AMD_BRAND_FILTER_ENABLED = true
/*sjjan9 start*/



export const CHAINCODE_ALL_BRANDS =  "SVALL"
export const CHAINCODE_MARRIOTT_BRANDS =  "marriott"
export const CHAINCODE_HILTON_BRANDS =  "hilton"
export const CHAINCODE_HYATT_BRANDS =  "hyatt"
export const CHAINCODE_WYNDHAM_BRANDS =  "wyndham"

export const PRICEGATEWAY_AMD =  "AMDSV"
export const PRICEGATEWAY_SOJOURN =  "SOJSV"


/*export const CHAINCODE_DEFAULT = CHAINCODE_ALL_BRANDS 
export const CHAINCODE_DEFAULT =  CHAINCODE_MARRIOTT_BRANDS 
export const PRICEGATEWAY_DEFAULT =  PRICEGATEWAY_AMD

*/
export const CHAINCODE_DEFAULT =  CHAINCODE_MARRIOTT_BRANDS
export const PRICEGATEWAY_DEFAULT =  PRICEGATEWAY_SOJOURN

/*sjjan9 end*/
export const AMENITY_ICON_MAP_OLD = {
    swimming : "heart",
    tennis : "sketch-square",
    water : "video-camera",
    other: "audio"

}

export const AMENITY_ICON_TYPE_MAP ={"HotTub":"credit-card","Spa":"sketch-square","Swimming_pool":"video-camera","Free_Wifi":"account-book","Free_Parking":"alert","Bath_Tub":"bell","24_Hrs Fitness":"book","Restaurants":"carry-out","Key_Card Access":"sketch-square","Non_Smoking":"contacts","Elevator":"compass","Shuttle_Service":"container","Snorkling_Service":"control","Laundry":"customer-service"}
export const AMENITY_ICON_COLOR_MAP ={"HotTub":"rgb(215, 125, 10)","Spa":"rgb(204, 102, 92)","Swimming_pool":"rgb(204, 102, 10)","Free_Wifi":"rgb(204, 160, 10)","Free_Parking":"rgb(204, 180, 10)","rgb(215, 200, 10)":"bell","24_Hrs Fitness":"rgb(215, 140, 10)","Restaurants":"rgb(215, 125, 10)","Key_Card Access":"sketch-rgb(215, 125, 10)","Non_Smoking":"rgb(215, 125, 10)","Elevator":"rgb(215, 125, 10)","Shuttle_Service":"rgb(215, 125, 10)","Snorkling_Service":"rgb(215, 125, 10)","Laundry":"rgb(215, 125, 10)"}



export const ADD_USER =  "ADD_USER"
export const FETCH_USERS = "FETCH_USERS"
export const FETCH_USER ="FETCH_USER"
export const REMOVE_USER = "REMOVE_USER"

export const RESET_USER_FORM=  "REMOVE_USER_FORM"
export const  UPDATE_USER_FORM= "UPDATE_USER_FORM"
export const FETCH_MOVIES = 'movies/FETCH_MOVIES'

export const FETCH_MOVIE ='movies/FETCH_MOVIE'
export const  LIST_TASKS = 'tasks/LIST_TASKS'
export const  LIST_SOJOURNS = 'tasks/LIST_SOJOURNS'
export const  GET_TASK = 'task/GET_TASK'
export const GET_ESSEARCH = 'essearch/GET_ESSEARCH'
export const  GET_EP = 'endpoint/GET_EP'
export const DELETE_TASK= 'task/DELETE_TASK'
export const CREATE_ACTION= 'task/CREATE_ACTION'
export const CREATE_STEP= 'task/CREATE_STEP'
export const CREATE_FLOW= 'task/CREATE_FLOW'

export const COUNTER_ACTION='task/COUNTER_ACTION'

export const LOAD_CLASSIFIER_FORM = 'classifier/LOAD_CLASSIFIER_FORM'
export const  LOAD_CLASSIFIERSTEP_CADOCFORM_EP = 'classifierStep/LOAD_CLASSIFIERSTEP_ADOCFORM_EP'

export const  LOAD_CLASSIFIERSTEP_CSTEPFORM = 'classifierStep/LOAD_CLASSIFIERSTEP_CSTEPFORM'
    export const  LOAD_CLASSIFIERSTEP_CSTEPFORM_EP = 'classifierStep/LOAD_CLASSIFIERSTEP_CSTEPFORM_EP'
export const  LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS = 'classifierStep/LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS'
export const  LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS = 'classifierStep/LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS'
export const LOAD_PD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS ='classifierStep/LOAD_PD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS'
export const LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS ='classifierStep/LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS'
export const LOAD_FORM_PC_BUS ='classifierStep/LOAD_FORM_PC_BUS'
export const LOAD_FORM_AD_BUS ='classifierStep/LOAD_FORM_AD_BUS'
export const LOAD_FORM_PD_BUS ='classifierStep/LOAD_FORM_PD_BUS'

export const LOAD_FORM_FPC_BUS ='classifierStep/LOAD_FORM_FPC_BUS'
/*svmay21 start*/
export const LOAD_FORM_PC_BUS_SH ='classifierStep/LOAD_FORM_PC_BUS_SH'
export const LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS_SH ='classifierStep/LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS_SH'

/*svmay21 end*/
export const LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS='classifierStep/LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS'
export const LOAD_GENE_UI_DATA_CSTEPFORM_BUS ='classifierStep/LOAD_GENE_UI_DATA_CSTEPFORM_BUS'
export const HIDE_MODAL_BA = 'classifierStep/HIDE_MODAL_BA'
export const SHOW_MODAL_BA = 'classifierStep/SHOW_MODAL_BA'
export const SHOW_LINECHART = 'classifierStep/SHOW_LINECHART'
export const SHOW_DOUGHNUTCHART = 'classifierStep/SHOW_DOUGHNUTCHART'
export const SHOW_CHARTTYPE = 'classifierStep/SHOW_CHARTTYPE'
export const CHANGE_DISPLAY_LINECHART = 'classifierStep/CHANGE_DISPLAY_LINECHART'

export const LOAD_MONITORS_MONITORFORM = 'monitors/LOAD_MONITORS_MONITORFORM'
export const LOAD_MONS = 'monitors/LOAD_MONS'

export const LOAD_MON = 'monitors/LOAD_MON'

export const LOAD_GVS = 'graphValues/GVS'
export const LOAD_GV= 'graphValues/GV'

export const LOAD_MON_MONFORM = 'monitors/LOAD_MON_MONFORM'
export const FORM_STRANDFORM ='classifierStep/LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS'
export const SVSTRANDFORM ='svstrandForm'
//FLY
export const SVFPDFORM ='svfpdForm'
export const SVTPPFORM ='svtppForm'
export const SVFPPFORM ='svfppForm'

export const SVFPCFORM ='svfpcForm'
export const SVFRCFORM ='svfrcForm'
export const SVFPIFORM ='svfpiForm'
//svnov17
export const SVMCIFORM ='svmciForm'
//tripper
export const SVTPIFORM ='svtpiForm'
//export const SVFPIFORM ='svfieldArrays'

//svmar20
export const CRSJCFORM = 'crsjcForm'
export const CRPDFORM ='crpdForm'
export const CRPCFORM ='crpcForm'
export const CRRCFORM ='crrcForm'

//svmay21
export const SJSJCFORM = 'sjsjcForm'
export const SJPDFORM ='sjpdForm'
export const SJPCFORM ='sjpcForm'
export const SJRCFORM ='sjrcForm'
//svf5

//svaug1y25
export const SJTDFORM ='sjtdForm'
export const SJTCFORM ='sjtcForm'
//svaug1y25 end
export const SVVPCFORM ='svvpcForm'


//Abode
export const SVPDFORM ='svpdForm'
export const SVPCFORM ='svpcForm'
export const SVRCFORM ='svrcForm'
//svfeb13
//AddressForm
export const SVPRFORM ='svprForm'
//AddressForm
export const SVADFORM ='svadForm'
//AddressForm
export const SVRDFORM ='svrdForm'
//CardForm
export const SVCDFORM ='svcdForm'
//loginForm
export const SVLAFORM ='svlaForm'

//RoomForm
export const SVROFORM ='svroForm'

export const LOAD_SVSTRANDS_DYNA = "classifierStep/LOAD_SVSTRANDS_DYNA"
export const SV_SERVER_ADDRESS = "http://localhost:3004/"



export const IM_AWS= "AWS_S3"
export const IM_PSURLS_AWS= "AWS_PRESIGN_PRIVATE" 
export const IM_SVAMCOS= "svamcos.svrenaissance.org"

export const IM_SOURCE_TYPE= "AWS_PRESIGN_PRIVATE"

export const IM_CDN= "BUNNY"





/* https://svamcos.svrenaissance.org/images/00/SVPS3/Z_NAS/1a_hb_es_003.jpg */

/*local 8086 HTTP ONLY or NO SSL testing 
//http://localhost:8086/images/soj5.jpg
//export const CARN_URL = "http://localhost:8086/images/"

export const SROOMIM_SOURCE_TYPE= IM_PSURLS_AWS
export const PROMO_SOURCE_TYPE= IM_CDN
export const SJCR_ORG_OVERLAY = false
export const SVPAGE_CR_PRESELECT = {SVREG_ID : 3333 , SVSHIP_CODE : 'SVALL', SVDUR_CODE : 'SVALL', SVORG_CODE : 'SVALL' }
export const CARN_URL = "https://svamcos.svrenaissance.org/images/"
export const COSMOS_IM_URL = "https://svrcosmos-assets.s3.us-east-1.amazonaws.com/"

export const SV_SOJ_ORCMOCK_ADDRESS = "http://localhost:8086"
export const SV_SOJ_SVDJMOCK_ADDRESS = "http://localhost:8000"
export const SV_PB_ORCMOCK_ADDRESS = "http://localhost:9082"
export const SV_SOJ_LOCALSTORAGE_TYPE = "SVDB"
export const SV_SOJ_SVDJMOCK_BRIDGE= "SVINGEST"
export const SV_SOJ_NOTCAROUSEL_VIEW = false
export const SJFACETNOBUTTON = true

//export const SV_SOJ_SVDJMOCK_BRIDGE= "SVDJMOCK"
//export const SV_SOJ_SVNAV_BRIDGE= "UATDEMO"
export const SV_SOJ_SVNAV_BRIDGE= "DEV"
export const COSMOS_SEGMENTS_DETAIL= "INLINE"
export const COSMOS_DEF_MAX_ALL_ADV_DAYS= "730"
export const COSMOS_DEF_SEARCH_ADV_DAYS= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_O= "15"
export const COSMOS_DEF_ROUND_ADV_DAYS_D= "91"
export const COSMOS_DEF_MCITY_ADV_DAYS_1= "14"
export const COSMOS_DEF_MCITY_ADV_DAYS_2= "29"
export const COSMOS_DEF_MCITY_ADV_DAYS_3= "34"
//export const COSMOS_SEGMENTS_DETAIL= "PANEL"

export const SJPROBATESHOW = true

//export const SV_SOJ_LOCALSTORAGE_TYPE = "SVCOOKIE"
*/

/*local 8086 https or SSL testing*/
/*
export const SROOMIM_SOURCE_TYPE= IM_AWS
export const PROMO_SOURCE_TYPE= IM_CDN
export const SJCR_ORG_OVERLAY = true
export const SVPAGE_CR_PRESELECT = {SVREG_ID : 3333 , SVSHIP_CODE : 'SVALL', SVDUR_CODE : 'SVALL', SVORG_CODE : 'SVALL' }
export const CARN_URL = "https://svamcos.svrenaissance.org/images/"
export const COSMOS_IM_URL = "https://svrcosmos-assets.s3.us-east-1.amazonaws.com/"
export const SV_SOJ_ORCMOCK_ADDRESS = "https://localhost:8086"
export const SV_SOJ_SVDJMOCK_ADDRESS = "http://localhost:8000"
export const SV_PB_ORCMOCK_ADDRESS = "http://localhost:9082"
export const SV_SOJ_LOCALSTORAGE_TYPE = "SVDB"
export const SV_SOJ_SVDJMOCK_BRIDGE= "SVINGEST"
export const SV_SOJ_NOTCAROUSEL_VIEW = false
export const SJFACETNOBUTTON = true
//export const SV_SOJ_SVDJMOCK_BRIDGE= "SVDJMOCK"
//export const SV_SOJ_SVNAV_BRIDGE= "UATDEMO"
export const SV_SOJ_SVNAV_BRIDGE= "DEV"
export const COSMOS_SEGMENTS_DETAIL= "INLINE"
export const COSMOS_DEF_MAX_ALL_ADV_DAYS= "730"
export const COSMOS_DEF_SEARCH_ADV_DAYS= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_O= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_D= "91"
export const COSMOS_DEF_MCITY_ADV_DAYS_1= "14"
export const COSMOS_DEF_MCITY_ADV_DAYS_2= "29"
export const COSMOS_DEF_MCITY_ADV_DAYS_3= "34"
//export const COSMOS_SEGMENTS_DETAIL= "PANEL"
export const SJPROBATESHOW = true


//export const SV_SOJ_LOCALSTORAGE_TYPE = "SVCOOKIE"


//move this to esingest noneed to parse get as string pass to  -http://52.52.125.226:8089
*/

/*
//http
export const SROOMIM_SOURCE_TYPE= IM_PSURLS_AWS
export const PROMO_SOURCE_TYPE= IM_CDN
export const SJCR_ORG_OVERLAY = true
export const SVPAGE_CR_PRESELECT = {SVREG_ID : 3333 , SVSHIP_CODE : 'SVALL', SVDUR_CODE : 'SVALL', SVORG_CODE : 'SVALL' }
export const CARN_URL = "http://svabode-1420502022.us-west-1.elb.amazonaws.com/images/"
export const COSMOS_IM_URL = "https://svrcosmos-assets.s3.us-east-1.amazonaws.com/"
export const SV_SOJ_ORCMOCK_ADDRESS = "http://svabode-1420502022.us-west-1.elb.amazonaws.com"
export const SV_SOJ_SVDJMOCK_ADDRESS = "http://52.52.125.226:8089"
//export const SV_SOJ_SVDJMOCK_ADDRESS = "http://52.52.125.226:8089"
export const SV_PB_ORCMOCK_ADDRESS = "http://localhost:9082"
export const SV_SOJ_LOCALSTORAGE_TYPE = "SVDB"
export const SV_SOJ_SVDJMOCK_BRIDGE= "SVINGEST"
export const SV_SOJ_NOTCAROUSEL_VIEW = false
export const SJFACETNOBUTTON = true
//export const SV_SOJ_SVNAV_BRIDGE= "PROD"
//export const SV_SOJ_SVNAV_BRIDGE= "UATDEMO"
export const SV_SOJ_SVNAV_BRIDGE= "DEV"
export const COSMOS_SEGMENTS_DETAIL= "INLINE"
export const COSMOS_DEF_MAX_ALL_ADV_DAYS= "730"
export const COSMOS_DEF_SEARCH_ADV_DAYS= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_O= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_D= "91"
export const COSMOS_DEF_MCITY_ADV_DAYS_1= "14"
export const COSMOS_DEF_MCITY_ADV_DAYS_2= "29"
export const COSMOS_DEF_MCITY_ADV_DAYS_3= "34"
//export const COSMOS_SEGMENTS_DETAIL= "PANEL"
export const SJPROBATESHOW = true

//export const SV_SOJ_SVDJMOCK_BRIDGE= "SVDJMOCK"

*/
/*aws https or ssl use this */

//curl --location    --request GET 'https://svamcos.svrenaissance.org/shpoint/svautocomplete?keyword=sea'
export const SROOMIM_SOURCE_TYPE= IM_PSURLS_AWS
export const PROMO_SOURCE_TYPE= IM_CDN
export const SJCR_ORG_OVERLAY = false
export const SVPAGE_CR_PRESELECT = {SVREG_ID : 3333 , SVSHIP_CODE : 'SVALL', SVDUR_CODE : 'SVALL', SVORG_CODE : 'SVALL' }
export const CARN_URL = "https://svamcos.svrenaissance.org/images/"
export const COSMOS_IM_URL = "https://svrcosmos-assets.s3.us-east-1.amazonaws.com/"
export const SV_SOJ_ORCMOCK_ADDRESS = "https://svamcos.svrenaissance.org"
//export const SV_SOJ_ORCMOCK_ADDRESS = "https://svabode-1420502022.us-west-1.elb.amazonaws.com"
export const SV_SOJ_SVDJMOCK_ADDRESS = "http://52.52.125.226:8089"
//export const SV_SOJ_SVDJMOCK_ADDRESS = "http://52.52.125.226:8089"
export const SV_PB_ORCMOCK_ADDRESS = "http://localhost:9082"
export const SV_SOJ_LOCALSTORAGE_TYPE = "SVDB"
export const SV_SOJ_SVDJMOCK_BRIDGE= "SVINGEST"
export const SV_SOJ_NOTCAROUSEL_VIEW = false
export const SJFACETNOBUTTON = true
export const SV_SOJ_SVNAV_BRIDGE= "PROD"
//export const SV_SOJ_SVNAV_BRIDGE= "UATDEMO"
//export const SV_SOJ_SVNAV_BRIDGE= "DEV"
export const COSMOS_SEGMENTS_DETAIL= "INLINE"
export const COSMOS_DEF_MAX_ALL_ADV_DAYS= "730"
export const COSMOS_DEF_SEARCH_ADV_DAYS= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_O= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_D= "91"
export const COSMOS_DEF_MCITY_ADV_DAYS_1= "14"
export const COSMOS_DEF_MCITY_ADV_DAYS_2= "29"
export const COSMOS_DEF_MCITY_ADV_DAYS_3= "34"
//export const COSMOS_SEGMENTS_DETAIL= "PANEL"
export const SJPROBATESHOW = false

//export const SV_SOJ_SVDJMOCK_BRIDGE= "SVDJMOCK"


export const SV_SERVICES={
    LOAD_STRANDS: 'getStrands',
    LOAD_TOR: 'getTor',

    LOAD_STRAND: 'getBindingAcceptorComplete',
    SAVE_STRAND: 'saveBindingAcceptorComplete',
    LOAD_BA_SLOT_FOR_GENE:'getBindingAcceptorSlotForGeneLib'
}

export const SV_URL =(SERVICE_NAME)=>{
    return SV_SERVER_ADDRESS + SERVICE_NAME

}

 
export const FANCY_MENU_METADATA = [
    {
      selected:false,
      fancyConfig:{
        pufancy :false,
        mychilds:[],
        puto : '/bus'
      },
      icon: "icon-home",
      menuDisp: "COSMOS",
      menuKey: "COSMOS(SVFlights)",
      exact: true,
      path: "/inetcosmos/svflysearch",
      component: "getLazyHome"
    },
    {
        selected:false,
        fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
      icon: "icon-code",
      menuDisp: "Sojourns",
      menuKey: "Sojourns",
      exact: true,
      path: "/inetabode/svessearch",
      component: "getLazyCode"
    }
   
  ]


  export const FANCY_DICON = {"0":{"fe":"first-feature","fnum":"first-number"},"1":{"fe":"second-feature","fnum":"second-number"},"2":{"fe":"second-feature","fnum":"second-number"},"3":{"fe":"first-feature","fnum":"first-number"},"4":{"fe":"second-feature","fnum":"second-number"},"5":{"fe":"second-feature","fnum":"second-number"},"6":{"fe":"first-feature","fnum":"first-number"},"7":{"fe":"second-feature","fnum":"second-number"},"8":{"fe":"second-feature","fnum":"second-number"},"9":{"fe":"first-feature","fnum":"first-number"},"10":{"fe":"first-feature","fnum":"first-number"},"11":{"fe":"second-feature","fnum":"second-number"},"12":{"fe":"first-feature","fnum":"first-number"},"13":{"fe":"first-feature","fnum":"first-number"},"14":{"fe":"second-feature","fnum":"second-number"},"15":{"fe":"first-feature","fnum":"first-number"},"16":{"fe":"first-feature","fnum":"first-number"},"17":{"fe":"second-feature","fnum":"second-number"},"18":{"fe":"first-feature","fnum":"first-number"},"19":{"fe":"second-feature","fnum":"second-number"},"20":{"fe":"second-feature","fnum":"second-number"},"21":{"fe":"first-feature","fnum":"first-number"},"22":{"fe":"second-feature","fnum":"second-number"},"23":{"fe":"second-feature","fnum":"second-number"},"24":{"fe":"first-feature","fnum":"first-number"},"25":{"fe":"second-feature","fnum":"second-number"},"26":{"fe":"second-feature","fnum":"second-number"},"27":{"fe":"first-feature","fnum":"first-number"},"28":{"fe":"second-feature","fnum":"second-number"},"29":{"fe":"second-feature","fnum":"second-number"},"30":{"fe":"first-feature","fnum":"first-number"},"31":{"fe":"second-feature","fnum":"second-number"},"32":{"fe":"second-feature","fnum":"second-number"},"33":{"fe":"first-feature","fnum":"first-number"},"34":{"fe":"second-feature","fnum":"second-number"},"35":{"fe":"second-feature","fnum":"second-number"},"36":{"fe":"first-feature","fnum":"first-number"},"37":{"fe":"second-feature","fnum":"second-number"},"38":{"fe":"second-feature","fnum":"second-number"},"39":{"fe":"first-feature","fnum":"first-number"},"40":{"fe":"second-feature","fnum":"second-number"},"41":{"fe":"second-feature","fnum":"second-number"},"42":{"fe":"first-feature","fnum":"first-number"},"43":{"fe":"second-feature","fnum":"second-number"},"44":{"fe":"second-feature","fnum":"second-number"},"45":{"fe":"first-feature","fnum":"first-number"},"46":{"fe":"second-feature","fnum":"second-number"},"47":{"fe":"second-feature","fnum":"second-number"},"48":{"fe":"first-feature","fnum":"first-number"},"49":{"fe":"second-feature","fnum":"second-number"},"50":{"fe":"second-feature","fnum":"second-number"},"51":{"fe":"first-feature","fnum":"first-number"},"52":{"fe":"second-feature","fnum":"second-number"},"53":{"fe":"second-feature","fnum":"second-number"},"54":{"fe":"first-feature","fnum":"first-number"},"55":{"fe":"second-feature","fnum":"second-number"},"56":{"fe":"second-feature","fnum":"second-number"},"57":{"fe":"first-feature","fnum":"first-number"},"58":{"fe":"second-feature","fnum":"second-number"},"59":{"fe":"second-feature","fnum":"second-number"},"60":{"fe":"first-feature","fnum":"first-number"},"61":{"fe":"second-feature","fnum":"second-number"},"62":{"fe":"second-feature","fnum":"second-number"},"63":{"fe":"first-feature","fnum":"first-number"},"64":{"fe":"second-feature","fnum":"second-number"},"65":{"fe":"second-feature","fnum":"second-number"},"66":{"fe":"first-feature","fnum":"first-number"},"67":{"fe":"second-feature","fnum":"second-number"},"68":{"fe":"second-feature","fnum":"second-number"},"69":{"fe":"first-feature","fnum":"first-number"},"70":{"fe":"second-feature","fnum":"second-number"},"71":{"fe":"second-feature","fnum":"second-number"},"72":{"fe":"first-feature","fnum":"first-number"},"73":{"fe":"second-feature","fnum":"second-number"},"74":{"fe":"second-feature","fnum":"second-number"},"75":{"fe":"first-feature","fnum":"first-number"},"76":{"fe":"second-feature","fnum":"second-number"},"77":{"fe":"second-feature","fnum":"second-number"},"78":{"fe":"first-feature","fnum":"first-number"},"79":{"fe":"second-feature","fnum":"second-number"},"80":{"fe":"second-feature","fnum":"second-number"},"81":{"fe":"first-feature","fnum":"first-number"},"82":{"fe":"second-feature","fnum":"second-number"},"83":{"fe":"second-feature","fnum":"second-number"},"84":{"fe":"first-feature","fnum":"first-number"},"85":{"fe":"second-feature","fnum":"second-number"},"86":{"fe":"second-feature","fnum":"second-number"},"87":{"fe":"first-feature","fnum":"first-number"},"88":{"fe":"second-feature","fnum":"second-number"},"89":{"fe":"second-feature","fnum":"second-number"},"90":{"fe":"first-feature","fnum":"first-number"},"91":{"fe":"second-feature","fnum":"second-number"},"92":{"fe":"second-feature","fnum":"second-number"},"93":{"fe":"first-feature","fnum":"first-number"},"94":{"fe":"second-feature","fnum":"second-number"},"95":{"fe":"second-feature","fnum":"second-number"},"96":{"fe":"first-feature","fnum":"first-number"},"97":{"fe":"second-feature","fnum":"second-number"},"98":{"fe":"second-feature","fnum":"second-number"},"99":{"fe":"first-feature","fnum":"first-number"},"100":{"fe":"second-feature","fnum":"second-number"},"101":{"fe":"second-feature","fnum":"second-number"},"102":{"fe":"first-feature","fnum":"first-number"},"103":{"fe":"second-feature","fnum":"second-number"},"104":{"fe":"second-feature","fnum":"second-number"},"105":{"fe":"first-feature","fnum":"first-number"},"106":{"fe":"second-feature","fnum":"second-number"},"107":{"fe":"second-feature","fnum":"second-number"},"108":{"fe":"first-feature","fnum":"first-number"},"109":{"fe":"second-feature","fnum":"second-number"},"110":{"fe":"second-feature","fnum":"second-number"},"111":{"fe":"first-feature","fnum":"first-number"},"112":{"fe":"second-feature","fnum":"second-number"},"113":{"fe":"second-feature","fnum":"second-number"},"114":{"fe":"first-feature","fnum":"first-number"},"115":{"fe":"second-feature","fnum":"second-number"},"116":{"fe":"second-feature","fnum":"second-number"},"117":{"fe":"first-feature","fnum":"first-number"},"118":{"fe":"second-feature","fnum":"second-number"},"119":{"fe":"second-feature","fnum":"second-number"},"120":{"fe":"first-feature","fnum":"first-number"},"121":{"fe":"second-feature","fnum":"second-number"},"122":{"fe":"second-feature","fnum":"second-number"},"123":{"fe":"first-feature","fnum":"first-number"},"124":{"fe":"second-feature","fnum":"second-number"},"125":{"fe":"second-feature","fnum":"second-number"},"126":{"fe":"first-feature","fnum":"first-number"},"127":{"fe":"second-feature","fnum":"second-number"},"128":{"fe":"second-feature","fnum":"second-number"},"129":{"fe":"first-feature","fnum":"first-number"},"130":{"fe":"second-feature","fnum":"second-number"},"131":{"fe":"second-feature","fnum":"second-number"}}
